/* eslint-disable sort-keys */

export default {
    Link: {
        baseStyle: { },
        sizes: {},
        variants: {
            brandColor: {
                _hover: {
                    textDecoration: "none",
                    color: "brand-dark"
                }
            },
            unstyled: {
                _hover: {
                    textDecoration: "none",
                }
            },
            subtleLink: ({ colorScheme }) => ({
                color: `${colorScheme || "accent1"}.300`, 
                fontSize: "xs"
            })
        },
        defaultProps: {},
    }
};
